var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopRated = function SvgTopRated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "topRated_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFC93F",
    mask: "url(#topRated_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.725 18.55q-.25.175-.5.012t-.15-.462L9.3 14.025l-3.125-2.25q-.25-.2-.162-.488Q6.1 11 6.425 11h3.9L11.6 6.8a.42.42 0 0 1 .4-.3q.126 0 .238.075t.162.225l1.275 4.2h3.9q.326 0 .413.287.087.288-.163.488l-3.125 2.25 1.225 4.075q.1.3-.15.462-.25.164-.5-.012L12 16.075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.083 20.866q-.375.26-.75.018-.375-.24-.226-.686L7.843 14.5a.5.5 0 0 0-.187-.552L3.293 10.82q-.414-.297-.244-.724.169-.425.581-.425h5.486a.5.5 0 0 0 .478-.353L11.4 3.445A.62.62 0 0 1 12 3q.188 0 .357.111a.62.62 0 0 1 .244.334l1.805 5.874a.5.5 0 0 0 .478.353h5.486q.412 0 .58.425.171.427-.243.724l-4.362 3.127a.5.5 0 0 0-.187.552l1.734 5.698q.15.445-.225.686-.375.24-.75-.018l-4.618-3.447a.5.5 0 0 0-.598 0zm1.314-2.817L12 15.343l3.603 2.706-1.314-4.485 3.34-2.41h-4.203L12 6.559l-1.426 4.597H6.37l3.34 2.409z"
  }))));
};
export default SvgTopRated;